module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-drawer', {
    attrs: {
      "title": "活动详情",
      "visible": _vm.visible,
      "direction": "rtl",
      "before-close": _vm.handleClose,
      "custom-class": "c-drawer",
      "wrapperClosable": false,
      "size": "65%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dataForm.title),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "title", $$v)
      },
      expression: "dataForm.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动类型",
      "prop": "cubeType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.dataForm.cubeType),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "cubeType", $$v)
      },
      expression: "dataForm.cubeType"
    }
  }, _vm._l((_vm.cubeTypeOptions), function(item) {
    return _c('el-option', {
      key: item.paraValue,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券",
      "prop": "couponId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择优惠券"
    },
    model: {
      value: (_vm.dataForm.couponId),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "couponId", $$v)
      },
      expression: "dataForm.couponId"
    }
  }, _vm._l((_vm.couponList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发放数量",
      "prop": "quantity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "clearable": "",
      "min": 1
    },
    on: {
      "change": function($event) {
        return _vm.handleNumChange(_vm.scope)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.dataForm.quantity),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "quantity", $$v)
      },
      expression: "dataForm.quantity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动页面",
      "prop": "page"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dataForm.page),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "page", $$v)
      },
      expression: "dataForm.page"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.dataForm.status),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "status", $$v)
      },
      expression: "dataForm.status"
    }
  }, _vm._l((_vm.activityStatusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动开始时间",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dataForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "startTime", $$v)
      },
      expression: "dataForm.startTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动结束时间",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dataForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "endTime", $$v)
      },
      expression: "dataForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动介绍",
      "prop": "content"
    }
  }, [_c('div', {
    attrs: {
      "id": "editor"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "channels"
    }
  }, [_c('div', {
    attrs: {
      "id": "tweetPictures"
    }
  }, [_c('div', {
    staticClass: "faultClass container"
  }, [_c('h4', [_vm._v("投放渠道")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.channelItems), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultClassListPart listPart"
    }, [_vm._v("\n                      " + _vm._s(item.title) + "\n                      "), _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editChannel(item)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          return _vm.deleteChannel(item)
        }
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addChannel({})
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2)]), _vm._v(" "), _c('biz-channel-info', {
    ref: "infoRef",
    on: {
      "refresh": _vm.renewInfo
    }
  })], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "drawer-footer"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dataFormSubmit()
      }
    }
  }, [_vm._v("确 定")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-188ca3aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/activity/components/activityEdit.vue
// module id = 1591
// module chunks = 0